import BaseRepository from 'Domain/Repositories/BaseRepository/BaseRepository';
import { Invoice }    from 'Domain/Models';

const config = {
  model: Invoice,
  baseRoute: '/admin/sales',
  singular: 'sales',
  plural: 'sales',
};

class SalesRepository extends BaseRepository<Invoice, typeof config.singular, typeof config.plural> {

  findDailySales() {
    return this.makeRequest({
      path: `${this.baseRoute}/daily`,
      type: 'GET',
      callback: ({ sales }) => sales,
    });
  }

  findMauDauWau() {
    return this.makeRequest({
      path: `${this.baseRoute}/mau-dau-wau`,
      type: 'GET',
      callback: ({ mau, dau, wau }) => ({ mau, dau, wau }),
    });
  }

}

export default new SalesRepository(config);
